import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="inline-block">
              <img 
                src="https://customer-assets.emergentagent.com/job_resilience-systems/artifacts/9niqxzqd_Image2.jpg" 
                alt="Sustainesis Global" 
                className="h-14 w-auto"
              />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Enabling sustainable transition through systems, data, and governance across Europe and beyond.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-sm text-gray-400 hover:text-red-600 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-sm text-gray-400 hover:text-red-600 transition-colors">Services</Link></li>
              <li><Link to="/eu-projects" className="text-sm text-gray-400 hover:text-red-600 transition-colors">Projects</Link></li>
              <li><Link to="/digital-solutions" className="text-sm text-gray-400 hover:text-red-600 transition-colors">Digital Solutions</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Core Focus</h3>
            <ul className="space-y-3">
              <li className="text-sm text-gray-400">Climate Resilience</li>
              <li className="text-sm text-gray-400">Sustainable Tourism</li>
              <li className="text-sm text-gray-400">Energy Systems</li>
              <li className="text-sm text-gray-400">Digital Solutions</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm text-gray-400">
                <MapPin size={16} className="mt-1 flex-shrink-0 text-red-600" />
                <span>170, Pater House, Level 1 (Suite A354), Triq Salvu Psaila, Birkirkara, BKR 9077, Malta</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <Mail size={16} className="flex-shrink-0 text-red-600" />
                <span>info@sustainesis.com</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <Phone size={16} className="flex-shrink-0 text-red-600" />
                <span>+356 2757 7000</span>
              </li>
            </ul>
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-gray-400 hover:text-red-600 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-600 transition-colors">
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} Sustainesis Global Ltd. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-sm text-gray-400 hover:text-red-600 transition-colors">Privacy Policy</a>
              <a href="#" className="text-sm text-gray-400 hover:text-red-600 transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
